import React, { useState, useEffect, useRef } from 'react';
import ProjectCard, { isProjectPost } from './ProjectCard';

// Load KaTeX CSS so math in posts renders correctly
if (!document.getElementById('katex-css')) {
  const link = Object.assign(document.createElement('link'), {
    id: 'katex-css', rel: 'stylesheet',
    href: 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css',
  });
  document.head.appendChild(link);
}

function PostCard({ post, onClick }) {
  return (
    <div className="project-card" style={{ cursor: 'pointer' }} onClick={onClick}>
      <div className="project-content" style={{ padding: '1.5rem' }}>
        <div className="project-header">
          <h4 style={{ marginBottom: '0.25rem' }}>{post.title}</h4>
          <span className="project-date">{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
        </div>
        <p className="project-description" style={{ marginTop: '0.75rem' }}>{post.excerpt}</p>
        <div className="project-links" style={{ marginTop: '1rem' }}>
          <span className="project-link" style={{ cursor: 'pointer' }}>Read more →</span>
        </div>
      </div>
    </div>
  );
}

function PostDetail({ post, onBack }) {
  const bodyRef = useRef(null);

  useEffect(() => {
    if (!bodyRef.current) return;
    bodyRef.current.querySelectorAll('.ql-post-html-embed').forEach(embed => {
      if (embed.dataset.fsAdded) return;
      embed.dataset.fsAdded = 'true';
      const iframe = embed.querySelector('iframe');
      if (!iframe) return;
      const wrap = iframe.parentElement;
      wrap.style.position = 'relative';
      const btn = document.createElement('button');
      btn.textContent = '⛶ Fullscreen';
      btn.style.cssText = [
        'position:absolute', 'top:8px', 'right:8px',
        'background:rgba(0,0,0,0.55)', 'color:#fff',
        'border:none', 'border-radius:4px',
        'padding:4px 10px', 'font-size:0.78rem',
        'cursor:pointer', 'z-index:10',
      ].join(';');
      btn.onclick = () => {
        const blob = new Blob([iframe.srcdoc], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      };
      wrap.appendChild(btn);
    });
  }, [post]);

  return (
    <div className="project-card" style={{ maxWidth: 960, margin: '0 auto' }}>
      <div className="project-content" style={{ padding: '2rem' }}>
        <button
          onClick={onBack}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', opacity: 0.6, marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.9rem' }}
        >
          ← Back to posts
        </button>
        <h2 style={{ marginBottom: '0.5rem' }}>{post.title}</h2>
        <p style={{ opacity: 0.6, fontSize: '0.9rem', marginBottom: '1.5rem' }}>
          {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
        <div
          ref={bodyRef}
          className="post-body"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </div>
    </div>
  );
}

export default function Posts() {
  const [posts, setPosts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/posts.json', { cache: 'no-store' })
      .then(r => r.json())
      .then(data => {
        const published = (data.posts || []).filter(p => p.published).sort((a, b) => new Date(b.date) - new Date(a.date));
        setPosts(published);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selected]);

  return (
    <div className="container" style={{ paddingTop: 'calc(72px + 2rem)' }}>
      {selected ? (
        <PostDetail post={selected} onBack={() => setSelected(null)} />
      ) : (
        <div className="main-content">
          <div className="projects-section">
            <h3 className="section-title">Posts</h3>
            {loading && <p style={{ opacity: 0.5 }}>Loading...</p>}
            {!loading && posts.length === 0 && (
              <p style={{ opacity: 0.5 }}>No posts yet.</p>
            )}
            <div className="projects-grid">
              {posts.map(post => isProjectPost(post) ? (
                <ProjectCard key={post.id} project={post} onClick={() => setSelected(post)} />
              ) : (
                <PostCard key={post.id} post={post} onClick={() => setSelected(post)} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
